import {FontSizes, vs} from '../../Utils/Dimensions';

import CCColors from '../../Utils/CCColors';
import {StyleSheet} from 'react-native';
import {hoverLift, pressSink, transition} from '../../Utils/motion';
import {radii} from '../../Utils/radius';

const cardPadding = 24;

export const styles = StyleSheet.create({
  mobileCard: {
    flexDirection: 'column',
  },
  circleContainer: {
    backgroundColor: CCColors.Primary.Brown,
    height: 35,
    width: 35,
    borderRadius: 25,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  reportsStrip: {
    width: '100%',
    backgroundColor: CCColors.Primary.lightBrown,
    borderRadius: 25,
    padding: 5,
    marginHorizontal: 5,
    marginVertical: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  trainerBox: {},
  gameplayCards: {
    flexBasis: '100%',
    flexDirection: 'row',
  },
  gameplayCardsMobile: {
    flexBasis: '100%',
    flexDirection: 'column',
  },
  container: {
    backgroundColor: CCColors.Primary.Light,
    padding: 24,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    // flex: 1,
    // height: '100%',
  },
  containerMobile: {
    // 8 here + each card's own 8 margin = the design's 16px mobile gutter.
    // Was 0, which left cards flush to the screen edges.
    padding: 8,
  },
  hoverCard: {
    shadowRadius: 20,
    shadowOffset: {
      width: 0,
      height: 8,
    },
    shadowOpacity: 0.2,
  },
  card: {
    margin: 8,
    padding: cardPadding,
    backgroundColor: '#fff',
    borderRadius: radii.panel,
    shadowColor: CCColors.Primary.Dark,
    shadowRadius: 8,
    overflow: 'hidden',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.05,
    overflow: 'hidden',
  },
  masterGameCard: {
    flex: 0.5,
  },
  masterGameCardMobile: {
    width: '100%',
  },
  masterGameAction: {
    borderRadius: 100,
  },
  masterGameContent: {
    borderColor: CCColors.BorderLight,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  masterGameContentMobile: {
    justifyContent: 'space-between',
  },
  masterGamePlayer: {
    flex: 0.33,
    justifyContent: 'center',
    alignItems: 'center',
  },
  masterGamePlayerMobile: {
    flex: 0.48,
    marginVertical: 10,
  },
  masterGamePlayerPhotoContainer: {
    borderWidth: 2,
    borderColor: CCColors.Primary.Brown,
    width: 84,
    height: 84,
    borderRadius: 100,
    overflow: 'hidden',
    marginBottom: 8,
  },
  masterGamePlayerPhoto: {
    width: 80,
    height: 80,
    borderRadius: 100,
    borderWidth: 2,
    borderColor: '#fff',
  },
  masterGamePlayerTitle: {
    position: 'absolute',
    backgroundColor: CCColors.Primary.Action,
    fontWeight: '600',
    fontSize: 10,
    bottom: 0,
    alignSelf: 'center',
    paddingHorizontal: 32,
    paddingVertical: 2,
  },
  masterGamePlayerName: {
    fontSize: 14,
    lineHeight: 24,
  },
  masterGamePlayerRating: {
    color: CCColors.TextColor.Grey,
    fontSize: 12,
    lineHeight: 16,
    fontWeight: '500',
  },

  masterGameTournament: {
    color: CCColors.TextColor.Grey,
    alignSelf: 'center',
    marginTop: 20,
    fontSize: 14,
    lineHeight: 18,
  },

  masterGameBoard: {
    flex: 0.34,
  },
  masterGameBoardMobile: {
    flex: 1,
  },
  PlayChessBG1: {
    height: '65%',
    width: '47%',
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  PlayChessBG: {
    height: '80%',
    width: '38%',
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  PlayChessBG2: {
    height: '70%',
    width: '34%',
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  PlayChessBG3: {
    height: '33%',
    width: '50%',
    position: 'absolute',
    zIndex: -1,
    right: 0,
    bottom: 0,
  },
  // Each top-level dashboard section is a full-width row inside the
  // row+wrap container (design: the page is a vertical stack of rows).
  fullRow: {
    width: '100%',
  },
  // Applied to a card that is a child of a row which has become a COLUMN at
  // narrow widths. Without it, the row's width split divides vertical space
  // instead of horizontal and the cards collapse or stretch oddly.
  stackedCol: {
    // NOT width:'100%' — these cards carry margin 8, so 100% + margins
    // overflowed the row by 16px and clipped off-screen on the right.
    alignSelf: 'stretch',
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: 'auto',
    minWidth: 0,
    // Cancels reviewGameCard/goalSection/assessmentSection's fixed calc()
    // width (see the note on reviewGameCard) — stackRows can be true here
    // while isMobileOrTab is false ('isNarrow'), which still picks the
    // desktop style, not the *Mobile variant. Without this override the card
    // stays pinned at ~70%/30% width even after the row goes vertical.
    width: 'auto',
  },
  // 0.7/0.3, matching the top band's carousel+grid vs leaderboard-rail split.
  // Every two-column row on the page uses this same ratio so the seam between
  // the left and right columns is one straight line from top to bottom; these
  // rows used to be 1.55fr/1fr (60.8/39.2), which kicked the seam sideways by
  // ~130px halfway down the page.
  //
  // NOT flex-grow (flex: 0.7/0.3, flexBasis: 0) — measured live in Chrome via
  // CDP, that gave 876.8px/885.2px here instead of the expected 896px on two
  // DIFFERENT rows using the exact same flex-grow ratio and container width,
  // and the gap didn't close even after forcing flex-grow/shrink/basis/min-
  // width/max-width identical and !important via direct DOM mutation — some
  // deeper flex free-space-distribution quirk specific to this row's content
  // that CSS overrides couldn't reach. An explicit calc() width sidesteps
  // that distribution step entirely and measured exactly on target (896.0px)
  // in the same live check. The `- 22.4px` is this item's 0.7 share of the
  // row's total reserved margin (2 cards x 8px left + 8px right = 32px).
  reviewGameCard: {
    flex: 'none',
    width: 'calc(70% - 22.4px)',
    minWidth: 0,
  },
  reviewGameCardMobile: {
    flex: 1,
    // flexBasis '100%' + the card's margin 8 overflowed by 16px.
    flexBasis: 'auto',
    alignSelf: 'stretch',
    minWidth: 0,
  },
  // Design: board is max-width 290 flex-shrink:0, stats column is flex:1
  // min-width:0 with a 24px gap.
  // The design caps the board at 290 because its column is ~640px wide. On a
  // full-width desktop this card is far wider, so a fixed 290 board left the
  // stats stretched across dead space — scale it with the card instead.
  reviewGameBoard: {
    width: '42%',
    maxWidth: 420,
    minWidth: 240,
    flexShrink: 0,
  },
  reviewGameDetails: {
    flex: 1,
    minWidth: 0,
    paddingLeft: 24,
  },
  reviewGameDetailsMobile: {
    flex: 1,
    // Was paddingLeft 5 / paddingRight 8 — asymmetric, so the stats block sat
    // a few px off the board's left edge above it. Stacked, both should align
    // flush to the card's own padding.
    paddingRight: 0,
    paddingLeft: 0,
  },

  reviewGameAction: {
    borderRadius: 100,
    // alignSelf: 'flex-end',
    // CCButton's built-in white hover overlay snapped on in a single frame;
    // this eases it. (CCButton doesn't expose `hovered` to its style prop, so
    // the lift/glow the other CTAs get isn't available here.)
    ...transition(180),
  },
  reviewGameActionMobile: {
    width: '100%',
    // alignSelf: 'flex-end',
  },

  reviewGameActionText: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '500',
    paddingRight: 16,
    // color: ''
  },
  reviewGameActionCoinsContainer: {
    backgroundColor: CCColors.Primary.Light,
    borderRadius: 100,
    padding: 4,
    paddingHorizontal: 16,
    // flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // height: 32
  },

  cardHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  cardHeadingIcon: {
    // borderRadius: 100,
    // paddingVertical: 8,
    // paddingHorizontal: 10,
    // height: 40,
    // width: 40,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',

    borderRadius: '50%',
    padding: 7,
    // display: 'flex',
  },

  cardHeadingTextContainer: {
    flexDirection: 'column',
    width: 'fit-content',
  },

  cardHeadingText: {
    fontWeight: '500',

    paddingVertical: 12,
    marginLeft: 12,
    // display: 'flex',
  },
  cardHeadingSubText: {
    fontSize: 14,
    lineHeight: 16,
    marginLeft: 12,
    color: CCColors.TextColor.Grey,
  },

  cardHeadingSubTextMobile: {
    width: '80%',
  },

  reviewGameText: {
    lineHeight: 20,
    // width: '70%',
    marginBottom: 16,
  },
  reviewMeters: {
    marginTop: 14,
    paddingTop: 14,
    borderTopWidth: 1,
    borderTopColor: CCColors.BorderLight,
    gap: 12,
  },
  reviewMeter: {},
  reviewMeterLabelRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  reviewMeterTrack: {
    height: 6,
    borderRadius: 99,
    backgroundColor: CCColors.Primary.lightBrown,
    overflow: 'hidden',
  },
  reviewMeterFill: {
    height: '100%',
    borderRadius: 99,
  },
  reviewGameStat: {
    marginVertical: 16,
  },
  reviewGameStatHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  reviewGameStatIcon: {
    marginRight: 8,
  },

  reviewGameStatHeadingText: {
    fontSize: 14,
    color: CCColors.TextColor.Grey,
    lineHeight: 24,
  },
  intuitionTrainerHeadingText: {
    fontSize: 16,
    color: CCColors.TextColor.Grey,
    lineHeight: 24,
  },

  reviewGameStatText: {
    fontSize: 14,
    lineHeight: 24,
  },

  reviewGameScoreStat: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
  },
  top12: {
    marginTop: vs(16),
  },
  reviewGameScoreStatHeadingText: {
    flexShrink: 1,
    fontSize: 12.5,
    color: CCColors.TextColor.Grey,
    lineHeight: 20,
  },

  reviewGameScoreStatText: {
    fontSize: 14,
    lineHeight: 24,
  },
  signInTypo: {
    textAlign: 'right',
    left: '50%',
    top: 48,
    color: CCColors?.Primary?.Default,
    position: 'absolute',
  },
  labelText: {
    width: '90%',
  },
  labelTextMobile: {
    width: '100%',
  },
  buttonStyles: {
    fontSize: FontSizes[9],
    paddingVertical: vs(3),
  },
  buttonWrapper: {},

  buttonWrapperMobile: {
    width: '70%',
    margin: 'auto',
  },

  scoreboardCard: {
    flex: 1,
  },

  scoreboardTable: {
    flex: 1,
  },
  scoreboardReviewButton: {
    borderRadius: 100,
  },

  tableHeader: {
    paddingVertical: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    // paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: CCColors.BorderLight,
    paddingHorizontal: cardPadding,
    marginHorizontal: -cardPadding,
  },
  headerColText: {
    color: CCColors.TextColor.Grey,
    lineHeight: 28,
    marginLeft: 16,
  },
  metaHeaderColText: {
    borderBottomWidth: 1,
    borderBottomColor: CCColors.Grey,
    borderStyle: 'dashed',
  },
  // goals
  // Two separate cards side by side, not one card with an internal divider —
  // so this is just the transparent row.
  goalsCard: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  // 0.7/0.3 with assessmentSection — see reviewGameCard's note on why this is
  // an explicit calc() width rather than flex-grow.
  goalSection: {
    flex: 'none',
    width: 'calc(70% - 22.4px)',
    minWidth: 0,
  },
  goalSectionMobile: {
    flex: 1,
    minWidth: 0,
  },
  mL16: {
    marginLeft: 16,
  },
  mL2: {
    marginLeft: 5,
  },
  // See reviewGameCard's note — 0.3's share of the row's 32px reserved margin
  // is 9.6px.
  assessmentSection: {
    flex: 'none',
    width: 'calc(30% - 9.6px)',
    minWidth: 0,
    justifyContent: 'space-between',
  },
  assessmentSectionMobile: {
    flex: 1,
    minWidth: 0,
    marginTop: 10,
    justifyContent: 'space-between',
  },

  // goalIcon: {},

  goalsContainer: {
    marginTop: 16,
    borderTopWidth: 1,
    borderColor: CCColors.Border,
    flexDirection: 'row',
  },
  goalsMobileContainer: {
    marginTop: 16,
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderBottomWidth: 1,
    borderColor: CCColors.Border,
    paddingBottom: 16,
  },
  goal: {
    borderColor: CCColors.Border,
    // Was flexBasis '46%' + flexShrink '45%' (an invalid, non-numeric
    // flexShrink) with flex 0.25 on top — 4 tiles at 46% basis can exceed the
    // column's flex share and widen the Goals card, which shifted the
    // Assessment card out of line with Club activity in the row below.
    // Four equal columns that can actually shrink:
    flex: 1,
    flexBasis: 0,
    minWidth: 0,
    justifyContent: 'space-between',
    borderRightWidth: 1,
    paddingTop: 24,
    paddingHorizontal: 20,
  },
  goalMobile: {
    backgroundColor: CCColors.Primary.lightBrown,
    borderWidth: 1,
    borderRadius: radii.chip,
    borderColor: 'transparent',
    margin: 5,
    flexBasis: '46%',
    flexShrink: '45%',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    flex: 0.5,
    padding: 10,
  },
  goalNumber: {
    fontWeight: '500',
    fontSize: 28,
    lineHeight: 36,
  },
  goalTitle: {
    fontWeight: '500',
    flexBasis: '95%',
  },
  goalSubTitle: {
    color: CCColors.TextColor.Grey,
    marginTop: 1,
    fontSize: 12,
  },
  goalSubTitleMobile: {
    width: '80%',
  },
  goalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  goalIcon: {
    borderRadius: 10,
    width: 34,
    height: 34,
    backgroundColor: CCColors.Primary.lightBrown,
    alignItems: 'center',
    justifyContent: 'center',
  },
  goalBarTrack: {
    height: 6,
    borderRadius: 99,
    backgroundColor: CCColors.BorderLight,
    overflow: 'hidden',
    marginTop: 8,
  },
  goalBarFill: {
    height: '100%',
    borderRadius: 99,
  },
  goalsTargetPill: {
    backgroundColor: CCColors.Primary.lightBrown,
    borderRadius: 99,
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  goalAction: {
    borderRadius: 100,
  },

  goalInfoIcon: {},

  assessmentScore: {
    fontSize: 30,
    fontWeight: '500',
    textAlign: 'center',
  },

  assessmentScoreContainer: {
    flexDirection: 'row',
    borderColor: CCColors.Border,
    borderBottomWidth: 1,
    paddingBottom: 24,
    paddingTop: 12,
  },
  assessmentMainScore: {
    flexDirection: 'column',
    flex: 0.33,
    justifyContent: 'center',
    // paddingRight: 16,
    borderColor: CCColors.Border,
    borderRightWidth: 1,
  },
  assessmentMainScore2: {
    flexDirection: 'column',
    flex: 0.33,
    justifyContent: 'center',
    // paddingRight: 16,
    borderColor: CCColors.Border,
    borderRightWidth: 1,
    paddingRight: 8,
  },
  assessmentBottomLabel: {
    justifyContent: 'center',
    fontSize: 12,
    width: '100%',
    textAlign: 'center',
  },
  assessmentSubScore: {
    paddingVertical: 4,
    // alignItems: 'center',
    // width: 320,
    // flexBasis: 80,
    // flex: 0.25,
  },
  upperBox: {
    width: '90%',
    height: '50%',
    overflow: 'hidden',
    position: 'absolute',
    top: 10,
    left: 10,
    paddingLeft: 10,
  },
  upperBoxMobile: {
    width: '100%',
    height: '40%',
    paddingLeft: 10,
  },
  rating: {
    height: '40%',
    width: '50%',
    overflow: 'hidden',
    position: 'absolute',
    top: '55%',
    left: 10,
    paddingLeft: 10,
  },
  ratingnum: {
    backgroundColor: '#3DAB9E',
    width: '40%',
    height: '60%',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: radii.chip,
  },
  bullseye: {
    borderRadius: '50%',
    // Pale wash, not a solid fill: the design's brand icons are full-colour
    // SVGs and would disappear on a saturated background.
    backgroundColor: '#F3EEFF',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bullseyeicon: {
    position: 'absolute',
    top: '50%',
    right: '50%',
    transform: [{translateX: '50%'}, {translateY: '-50%'}],
  },
  speedometer: {
    position: 'absolute',
    top: '50%',
    right: '50%',
    transform: [{translateX: '50%'}, {translateY: '-50%'}],
    height: 20,
    width: 20,
  },
});
